import styled from "styled-components";

export const ButtonWrapper = styled.div`
  & button {
    height: auto;
    padding: 19px 16px;
    width: 100%;
  }
`;
